<template>
    <div v-if="category" class="filter-sidebar">
        <div class="filter-sidebar__row" v-if="beforeAfter && checkFilter('시공전후')">
            <div class="flexbox">
                <label class="check">
                    <input class="input" type="checkbox" v-model="before">
                    <i class="icon"></i>
                    <span class="text">시공 전후 비교사진</span>
                </label>
            </div>
        </div>
        <div class="filter-sidebar__row" v-if="checkFilter('평수')">
            <span class="filter-sidebar__title">
                <span>평수 </span><small>{{ toArea() }}</small>
            </span>
            <div class="range-slider-container">
                <vue-slider v-model="area" :max="100"></vue-slider>
            </div>
        </div>
        <div class="filter-sidebar__row" v-if="checkFilter('비용')">
            <span class="filter-sidebar__title">
                <span>비용</span><small>{{ toPrice() }}</small>
            </span>
            <div class="range-slider-container">
                <vue-slider v-model="price" :max="10000"></vue-slider>
            </div>
        </div>
        <div class="filter-sidebar__row" v-if="checkFilter('컨셉')">
            <span class="filter-sidebar__title">컨셉</span>
            <div class="check-block-container">
                <label class="check-block" v-for="(item, index) in concept_item" :key="index">
                    <input class="input" type="checkbox" :value="item" v-model="concept">
                    <span class="button button--border-primary">{{ item }}</span>
                </label>
            </div>
        </div>
        <div class="filter-sidebar__row" v-if="checkFilter('컬러')">
            <span class="filter-sidebar__title">컬러</span>
            <div class="check-color-container">
                <label class="check-color" v-for="(item, index) in color_item" :key="index">
                    <input class="input" type="checkbox" :value="item" v-model="color">
                    <!--
                        #아이콘 배경컬러 인라인스타일.
                        컬러가 화이트 일때만 i.icon태그에 서브클래스 추가: icon--primary
                        아이보리: #fffdea
                        옐로: #ffd21d
                        골드: #dbc183
                        브라운: #9e6148
                        레드: #d43636
                        핑크: #f987b2
                        퍼플: #8766b0
                        블루: #3e5fd7
                        그림: #30cd84
                        그레이: #818181
                        블랙: #000000
                    -->
                    <i class="icon" :class="{'icon--primary' : item == '아이보리' || item == '화이트'}" :style="backColor(item)">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15px" height="15px">
                            <path fill-rule="evenodd" stroke-width="2px" stroke-linecap="round" stroke-linejoin="miter" fill="none" d="M3.000,8.000 L6.000,12.000 L11.000,2.000 "/>
                        </svg>
                    </i>
                    <span class="text">{{item}}</span>
                </label>
            </div>
        </div>
        <div class="filter-sidebar__row" v-if="category.filters.length > 0">
            <div class="bottom-button">
                <button class="button button--border button--rotate-left" @click="refresh"><span class="blind">새로고침</span></button>
                <button class="button button--primary" @click="input"><span>검색하기</span></button>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
    components : {
        VueSlider
    },
    props: {
        value: { type: Object, default: null },
        beforeAfter: { type: Boolean, default: false }
    },
    data() {
        return {
            filter: this.$props.value,

            category: null,

            before: false,
            area : [0,100],
            price : [0,10000],
            concept : [],
            color : [],

            concept_item : ["심플","모던","내추럴","빈티지","클래식","럭셔리"],
            color_item : [
                "화이트","아이보리","옐로",
                "골드","브라운","레드",
                "핑크","퍼플","블루",
                "그린","그레이","블랙"
            ]
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        async init(){
            if(this.filter._category){
                var { category } = await api.v1.portfolios.categories.getCategory({ _id: this.filter._category });
                this.category = category;
            }
        },
        input(){
            var filter = Object.assign({}, this.filter, {
                "space.beforeEnable": this.before ? this.before : null,
                "construction.acreage": this.area,
                "construction.supplyPrice": this.price,
                "construction.discountPrice": this.price,
                "construction.concept": this.concept,
                "construction.color": this.color
            });

            this.filter = filter;

            this.$emit("input", filter);
        },
        toPrice() {
            var price = this.price;
            if(price[0] == 0 && price[1] == 10000) {
                return "전체";
            }else {
                return price[1] === 10000 ? `${price[0]} 만원대 ~ 전체` : `${price[0]} ~ ${price[1]} 만원대`;
            }
        },
        toArea() {
            var area = this.area;
            if(area[0] == 0 && area[1] == 100) {
                return "전체";
            }else {
                return area[1] === 100 ? `${area[0]} 평대 ~ 전체 ` : `${area[0]} ~ ${area[1]} 평대`;
            }
        },
        backColor(color) {
            switch (color) {
                case "아이보리":
                    return { "backgroundColor" : "#fffdea"};
                case "옐로" :
                    return { "backgroundColor" : "#ffd21d"};
                case "골드" :
                    return { "backgroundColor" : "#dbc183"};
                case "브라운" :
                    return { "backgroundColor" : "#9e6148"};
                case "레드" :
                    return { "backgroundColor" : "#d43636"};
                case "핑크" :
                    return { "backgroundColor" : "#f987b2"};
                case "퍼플" :
                    return { "backgroundColor" : "#8766b0"};
                case "블루" :
                    return { "backgroundColor" : "#3e5fd7"};
                case "그린" :
                    return { "backgroundColor" : "#30cd84"};
                case "그레이" :
                    return { "backgroundColor" : "#818181"};
                case "블랙" :
                    return { "backgroundColor" : "#000000"};
            }
        },
        refresh() {
            this.before = false;
            this.area = [0, 100]
            this.price = [0, 10000];
            this.concept = [];
            this.color = [];

            this.input();
        },
        checkFilter(name) {
            for(var filter of this.category.filters) {
                if(filter.name == name) {
                    return filter.use;
                }
            }
        }
    },
    computed: {
        _category(){
            return this.filter._category;
        }
    },
    watch: {
        _category() {
            this.$emit("search");
        },
    }
}
</script>

<style lang="css" scoped>
</style>
